import ContainerLayout from 'components/ContainerLayout'
import usePublic from 'context/public-context/hook'
import OfferSummary from './OfferSummary'

export default function Offers() {

	const {loadingOffers, offers} = usePublic()

	return (
		<ContainerLayout 
			title="Adéntrate a un universo educativo lleno de infinitas posibilidades"
			description="Ofrecemos planes que se adaptan a tus necesidades"
			loading={loadingOffers}
		>
			{offers.map((offer) => (
					<OfferSummary
						key={offer.id}
						offer={offer}
					/>
				))
			}
		</ContainerLayout>
	)
}
